export default {
    CREADA : "Práctica creada",
    CREADA_PROCESO : "Cronograma en Proceso de creación",
    PENDIENTE_APROBACION : "Práctica pendiente de aprobación por DNERHS",
    PRACTICA_RECHAZADA : "Práctica con correcciones solicitadas por DNERHS",
    PRACTICA_APROBADA : "Práctica aprobada por DNERHS",
    PRACTICA_PENDIENTE_MODIFICACIONES_APROBACION : "Práctica con modificaciones pendientes de aprobación por DNERHS",
    PRACTICA_MODIFICACIONES_APROBADA : "Práctica con modificaciones aprobadas por DNERHS",
    PRACTICA_CRONOGRAMA_FINALIZADA : "Práctica cronograma finalizada"
}